import { useQuery } from "@tanstack/react-query";
import { apiRequest } from "@core/services/api/apiRequest";

/** What the backend can count about the network; null where it cannot. */
export type NetworkSnapshot = {
  participants: number;
  organizations: number;
  facilitator_share: number | null;
  collective_members: number | null;
  researchers_faculty: number | null;
  fulbright_fellows: number | null;
  guggenheim_fellows: number | null;
  founders_org_leaders: number | null;
  countries: number | null;
  invited_by_peer: number | null;
  peer_groups: number | null;
  grantmaker_sharing_share: number | null;
};

/**
 * The counted facts behind the network snapshot panel.
 *
 * Fetched rather than written into the page, so the panel's figures move with
 * the network instead of fossilising in copy. A figure the backend cannot
 * honestly compute comes back null, and the panel shows its placeholder.
 */
export function useNetworkSnapshot() {
  return useQuery({
    queryKey: ["networkSnapshot"],
    queryFn: (): Promise<NetworkSnapshot> =>
      apiRequest("/marketing/network-snapshot/", "GET", undefined, false),
    staleTime: 60 * 60 * 1000,
  });
}
